import { createDecorator } from '../../instantiation/common/instantiation.js';
const IListService = ( createDecorator('listService'));
export { IListService };
